"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkOXTEV2FIcjs = require('./chunk-OXTEV2FI.cjs');


var _chunk7MHI5INWcjs = require('./chunk-7MHI5INW.cjs');

// src/contracts/farm/v2/index.ts
var FARM = {
  NftItem: _chunkOXTEV2FIcjs.FarmNftItemV2,
  NftMinter: _chunk7MHI5INWcjs.FarmNftMinterV2
};



exports.FARM = FARM;
//# sourceMappingURL=chunk-ODN24ORC.cjs.map